import React from "react";
import { connect } from "react-redux";

import { setGameState } from "../../store/reducers";
import { Button } from "../../atoms/Buttons/Base";
import { ProgressiveImage } from "../../atoms/ProgressiveImage/ProgressiveImage";
import { Text } from "../../atoms/Text/Text";
import { Ribbon } from "../../atoms/Ribbon/Ribbon";
import { RewardLabel } from "../../atoms/RewardLabel/RewardLabel";
import { Game } from "../../models/Game";
import { GameState } from "../../models/Enums";
import styles from "./GameCover.css";
import { CoverBlock } from "./CoverBlock";
import Modal from "../../atoms/Modal/Modal";
import { checkFullPath } from "../../../utils";
import AARPAuthService from "../../services/AARPAuthService";
import { PreviewMode } from "../../services/PreviewModeService";

type GameCoverProps = {
  game: Game;
  gameState: GameState;
  previewMode?: PreviewMode;
  dispatch?: any;
};

export class GameCoverDumb extends React.PureComponent<GameCoverProps> {
  static displayName = "GameCover";
  state = {
    showCoverPopup: true,
  };

  onCoverPopupClose = () => {
    this.setState({ showCoverPopup: false });
  };

  onPlayClick = (e) => {
    this.props.gameState === GameState.COVER_SKIP_PREROLL
      ? this.props.dispatch(setGameState(GameState.GAME))
      : this.setState({ showCoverPopup: true });
  };

  handlerLogin() {
    location.href = AARPAuthService.getNewLoginUrl();
  }

  handlerRegister() {
    location.href = AARPAuthService.getRegisterUrl();
  }

  render() {    
    const { game, gameState, previewMode } = this.props;

    return (
      <React.Fragment>
        {this.state.showCoverPopup && gameState === GameState.COVER_MEMBER && (
          <CoverBlock
            slug={game.slug}
            gameName={game.seo_GameName}
            gameState={gameState}
            onClose={this.onCoverPopupClose}
          />
        )}

        {previewMode &&
          gameState === GameState.COVER_PREVIEW_MODE && (
            <Modal
              modalTheme="secondary"
              header={previewMode.highlightText}
              headerTitle={previewMode.title}
              content={<span dangerouslySetInnerHTML={{ __html: previewMode.subtitleHtml }} />}
              onClose={() => this.onCoverPopupClose()}
              onConfirm={() => this.handlerLogin()}
              footerClick={() => this.handlerRegister()}
              confirmButtonText="Log In"
              isSectionModal
              hasCloseIcon={false}
              size="sm"
              roundedCorners={false}
              footerText="Not Registered? Create Account >"
            />
          )}

        <Container data-element-description="game cover">
          <Overlay />
          <Ribbon size="large" game={game} className={styles.gameCoverRibbon} />
          <RewardLabel size="large" game={game} />
          <ProgressiveImage
            alt={game.seo_GameName}
            image={checkFullPath(game.assetOriginUrl, game.promoThumbPath).toString()}
            useParentSize={true}
            loadWhenViewable={true}
          />
          <PlayButton
            aria-label="game play button"
            data-element-description="game cover button"
            onClick={this.onPlayClick}
          >
            <Text bold={true}>PLAY NOW</Text>
          </PlayButton>
        </Container>
      </React.Fragment>
    );
  }
}
export const GameCover = connect()(GameCoverDumb);

const Overlay = (props: any) => (
  <div className={styles.gameCoverOverlay} {...props} />
);
const Container = (props: any) => (
  <div className={styles.gameCoverContainer} {...props} />
);
const PlayButton = (props: any) => (
  <Button className={styles.gameCoverPlayButton} {...props} />
);
